import { ModalidadI } from "interfaces/Modalidad";

export interface infoFetchGetModalidadI {
  id: number | string;
  nombre: string;
}

class Modalidad implements ModalidadI {
  id: number | string;
  nombre: string;

  constructor(dto: infoFetchGetModalidadI) {
    this.id = dto.id;
    this.nombre = dto.nombre;
  }
}

export const makeModalidad = (infoFetch: infoFetchGetModalidadI) => {
  return new Modalidad(infoFetch);
};
